//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name:'operationBoard',
  data(){
    return {
      period:'today',
      customStart:'',
      customEnd:'',
      draftStart:'',
      draftEnd:'',
      customVisible:false,
      dateError:'',
      loading:false,
      errorText:'',
      requestId:0,
      summary:{by_type:{},sources:{}},
      periods:[
        {key:'today',label:'今日'},
        {key:'yesterday',label:'昨日'},
        {key:'week',label:'本周'},
        {key:'month',label:'本月'},
        {key:'year',label:'本年'},
        {key:'custom',label:'自定义'}
      ],
      cardTypes:[
        {key:'package',label:'次卡',color:'#2d7ff9'},
        {key:'stored',label:'储值',color:'#16b5a0'},
        {key:'discount',label:'折扣卡',color:'#e8b04b'},
        {key:'year',label:'年卡',color:'#8b5cf6'}
      ]
    }
  },
  computed:{
    todayDate(){
      var now=new Date();
      var month=('0'+(now.getMonth()+1)).slice(-2);
      var day=('0'+now.getDate()).slice(-2);
      return now.getFullYear()+'-'+month+'-'+day;
    },
    sourceList(){
      var sources=this.summary.sources || {};
      return ['laundry','housework','card'].map(function(key){
        var item=sources[key] || {};
        return {key:key,label:item.label || ({laundry:'洗衣',housework:'家政',card:'会员卡'}[key]),amount:Number(item.amount)||0,percent:Number(item.percent)||0};
      });
    }
  },
  created(){
    var requested=String(this.$route.query.period || 'today');
    if(this.periods.some(item=>item.key === requested)) this.period=requested;
    if(this.period === 'custom'){
      this.customStart=String(this.$route.query.start_date || '');
      this.customEnd=String(this.$route.query.end_date || '');
      if(!this.customStart || !this.customEnd) this.period='today';
    }
    this.loadSummary();
  },
  methods:{
    changePeriod(period){
      if(this.loading) return;
      if(period === 'custom'){
        this.openCustomDate();
        return;
      }
      if(this.period === period) return;
      this.period=period;
      this.customStart='';
      this.customEnd='';
      this.$router.replace({name:'operationBoard',query:{period:period}});
      this.loadSummary();
    },
    openCustomDate(){
      this.draftEnd=this.customEnd || this.todayDate;
      this.draftStart=this.customStart || this.draftEnd;
      this.dateError='';
      this.customVisible=true;
    },
    closeCustomDate(){ this.customVisible=false;this.dateError=''; },
    applyCustomDate(){
      if(!this.draftStart || !this.draftEnd){ this.dateError='请选择开始和结束日期';return; }
      if(this.draftStart > this.draftEnd){ this.dateError='开始日期不能晚于结束日期';return; }
      if(this.draftEnd > this.todayDate){ this.dateError='结束日期不能超过今天';return; }
      var days=(new Date(this.draftEnd+'T00:00:00')-new Date(this.draftStart+'T00:00:00'))/86400000;
      if(days > 366){ this.dateError='自定义日期最多选择366天';return; }
      this.period='custom';
      this.customStart=this.draftStart;
      this.customEnd=this.draftEnd;
      this.customVisible=false;
      this.$router.replace({name:'operationBoard',query:this.periodQuery()});
      this.loadSummary();
    },
    periodQuery(){
      var query={period:this.period};
      if(this.period === 'custom'){
        query.start_date=this.customStart;
        query.end_date=this.customEnd;
      }
      return query;
    },
    loadSummary(){
      var current=++this.requestId;
      this.loading=true;
      this.errorText='';
      this.$api.operationBoardSummary(this.periodQuery()).then((res)=>{
        if(current !== this.requestId) return;
        this.loading=false;
        if(res && res.data){
          this.summary=res.data;
          return;
        }
        this.errorText='经营数据加载失败';
      }).catch(()=>{
        if(current !== this.requestId) return;
        this.loading=false;
        this.errorText='经营数据加载失败，请稍后重试';
      });
    },
    openDetail(dimension){
      var query=this.periodQuery();
      query.dimension=dimension;
      this.$router.push({name:'operationBoardDetail',query:query});
    },
    typeAmount(key){ var item=this.summary.by_type && this.summary.by_type[key];return item && item.amount || 0; },
    typeCount(key){ var item=this.summary.by_type && this.summary.by_type[key];return item && item.count || 0; },
    money(value){
      var number=Number(value)||0;
      return number.toLocaleString('zh-CN',{minimumFractionDigits:0,maximumFractionDigits:2});
    },
    count(value){ return (Number(value)||0).toLocaleString('zh-CN'); },
    percent(value){
      var number=Number(value)||0;
      return (number % 1 === 0 ? number.toFixed(0) : number.toFixed(1)) + '%';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/operationBoard.vue